import { useSubscription } from '@apollo/client';
import { FC } from 'react';
import { GATE_MESSAGE_RECEIVED } from '../graphql/subscriptions/gateMessageReceived';

export const GateMessagesSubscription: FC = () => {
  useSubscription(GATE_MESSAGE_RECEIVED);

  return null;
};
